import { API_ENDPOINT } from "@/constants/appConstants";
import { getHttpMethod } from "@/helpers/getHttpMethod";
import { useProfileSectionData } from "@/hooks";
import {
  PROFILE_QUERY_KEY,
  PROFILE_STATS_QUERY_KEY,
  VALIDATE_PROFILE_QUERY_KEY,
} from "@/lib/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ActionType, ErrorResponse } from "../types";
import { SkillApiType } from "./type";

// export const getSkills = (): UseQueryResult<SkillApiType, Error> => {
//   return useQuery({
//     queryKey: [SKILLS_QUERY_KEY],
//     queryFn: () => profileAPI<SkillApiType>("skills_and_it_skills"),
//   });
// };

// export const getSuggestedKeywords = () => {
//   return useQuery({
//     queryKey: [SUGGESTED_KEYWORDS],
//     queryFn: () => profileAPI("skills_and_it_skills"),
//   });
// };

export const getSkills = () => {
  return useProfileSectionData<SkillApiType>("skillSection");
};

export const useSkill = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      data,
      action = "add",
    }: {
      data: any;
      action: ActionType;
    }) => {
      const method = getHttpMethod(action);
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.skill,
        {
          method,
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      // queryClient.invalidateQueries({ queryKey: [SKILLS_QUERY_KEY] });
      // for updating the profile score
      queryClient.invalidateQueries({ queryKey: [PROFILE_STATS_QUERY_KEY] });
      // for updating the l1 apop action_type
      queryClient.invalidateQueries({ queryKey: [VALIDATE_PROFILE_QUERY_KEY] });
    },
  });
};
